if (!customElements.get('rd-home-slideshow')) {
  customElements.define(
    'rd-home-slideshow',
    class RoomdenHomeSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-home-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-slide-to]'));
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.interval = Number(this.dataset.interval) || 6000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.show(Number(dot.dataset.slideTo), true));
        });

        this.addEventListener('mouseenter', () => this.stopTimer());
        this.addEventListener('mouseleave', () => this.startTimer());
        this.addEventListener('focusin', () => this.stopTimer());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.startTimer();
        });

        this.handleVisibility = () => {
          if (document.hidden) this.stopTimer();
          else this.startTimer();
        };
        document.addEventListener('visibilitychange', this.handleVisibility);

        this.handleBlockSelect = (event) => {
          const slide = event.target.closest('[data-home-slide]');
          if (slide && this.contains(slide)) this.show(Number(slide.dataset.slideIndex), true);
        };
        document.addEventListener('shopify:block:select', this.handleBlockSelect);

        this.show(this.currentIndex);
        this.startTimer();
      }

      disconnectedCallback() {
        this.stopTimer();
        document.removeEventListener('visibilitychange', this.handleVisibility);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      show(index, resetTimer = false) {
        if (!this.slides.length) return;
        const nextIndex = (index + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === nextIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
          slide.querySelectorAll('video').forEach((video) => {
            if (active) video.play().catch(() => {});
            else video.pause();
          });
        });

        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === nextIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });

        this.currentIndex = nextIndex;
        if (resetTimer) {
          this.stopTimer();
          this.startTimer();
        }
      }

      startTimer() {
        if (!this.autoplay || this.reducedMotion || document.hidden || this.timer) return;
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.interval);
      }

      stopTimer() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

    }
  );
}
